// extracted by mini-css-extract-plugin
export default {"navMenu":"navbar_navMenu__wvh02"};